import { AdminRole } from '../types';

export interface PresetAdminAccount {
  username: string;
  name: string;
  role: AdminRole;
  outletId?: string;
  outletName?: string;
}

export const PRESET_ADMIN_ACCOUNTS: PresetAdminAccount[] = [
  {
    username: 'admin',
    name: 'Super Admin Pusat',
    role: 'super_admin',
    outletName: 'Seluruh Website & Semua Outlet',
  },
  {
    username: 'sudirman',
    name: 'Admin Chapter 5 - Sudirman',
    role: 'outlet_admin',
    outletId: 'sudirman',
    outletName: 'Chapter 5 - Leton Sudirman',
  },
  {
    username: 'kelakap',
    name: 'Admin Chapter 6 - Kelakap 7',
    role: 'outlet_admin',
    outletId: 'kelakap_7',
    outletName: 'Chapter 6 - Leton Kelakap 7',
  },
  {
    username: 'letgo',
    name: "Admin Let'GO - Mobile",
    role: 'outlet_admin',
    outletId: 'letgo-mpp',
    outletName: "Let'GO - MPP & Mobile",
  },
  {
    username: 'courier_sudirman',
    name: 'Kurir Chapter 5 - Sudirman',
    role: 'courier',
    outletId: 'sudirman',
    outletName: 'Chapter 5 - Leton Sudirman',
  },
  {
    username: 'courier_kelakap',
    name: 'Kurir Chapter 6 - Kelakap 7',
    role: 'courier',
    outletId: 'kelakap_7',
    outletName: 'Chapter 6 - Leton Kelakap 7',
  },
];

export function findPresetAdmin(username: string): PresetAdminAccount | undefined {
  if (!username) return undefined;
  const clean = username.trim().toLowerCase();
  return PRESET_ADMIN_ACCOUNTS.find((acc) => acc.username.toLowerCase() === clean);
}

export function matchesOutlet(outletId?: string, targetOutletId?: string): boolean {
  if (!targetOutletId || targetOutletId === 'ALL' || targetOutletId === 'global') return true;
  if (!outletId) return false;
  const o = String(outletId).toLowerCase().trim();
  const t = String(targetOutletId).toLowerCase().trim();
  if (o === t) return true;
  // Aliases for Sudirman
  if ((o.includes('sudirman') || o === 'chapter-5') && (t.includes('sudirman') || t === 'chapter-5')) return true;
  // Aliases for Kelakap 7 / Ratu Sima
  if ((o.includes('kelakap') || o.includes('ratu') || o === 'chapter-6') && (t.includes('kelakap') || t.includes('ratu') || t === 'chapter-6')) return true;
  // Aliases for Let'GO
  if ((o.includes('letgo') || o.includes('mpp')) && (t.includes('letgo') || t.includes('mpp'))) return true;
  return false;
}
